<template>
	<div class="app">
		<div class="page-container">
			<div class="content">
        <div class="logo">
          <img src="../../src/static/img/P3LOGO.png" alt="">
        </div>
				<div class="banner">
          <div class="linkrow com-flex-row com-center">
            <div class="left com-center">
                {{ convertDomain(urlViewList[0]) }}
            </div>
            <div class="com-flex-right com-center" @click="toUrlLink('link',0)">
              <div class="tourlbtn com-center">Truy cập</div>
            </div>
          </div>
          <div class="linkrow com-flex-row com-center">
            <div class="left com-center">
              {{ convertDomain(urlViewList[1]) }}
            </div>
            <div class="com-flex-right com-center" @click="toUrlLink('link',1)">
              <div class="tourlbtn com-center">Truy cập</div>
            </div>
          </div>
          <div class="linkrow com-flex-row com-center">
            <div class="left com-center">
              {{ convertDomain(urlViewList[2]) }}
            </div>
            <div class="com-flex-right com-center" @click="toUrlLink('link',2)">
              <div class="tourlbtn com-center">Truy cập</div>
            </div>
          </div>
          <div class="linkrow com-flex-row com-center">
            <div class="left com-center">
              {{ convertDomain(urlViewList[3]) }}
            </div>
            <div class="com-flex-right com-center" @click="toUrlLink('link',3)">
              <div class="tourlbtn com-center">Truy cập</div>
            </div>
          </div>
          <div class="linkrow com-flex-row com-center">
            <div class="left com-center">
              {{ convertDomain(urlViewList[4]) }}
            </div>
            <div class="com-flex-right com-center" @click="toUrlLink('link',4)">
              <div class="tourlbtn com-center">Truy cập</div>
            </div>
          </div>

          <div class="foot-row com-flex-row com-center"  @click="toUrlLink('download',0)">
<!--            <img src="../../src/static/img/appD.png" alt="">-->
            <div class="approw com-flex-row com-center">
              <img src="../../src/static/img/PCxiazai.png" alt="">
              TẢI APP
            </div>
          </div>

          <div class="foot-row com-flex-row com-center"  @click="toUrlLink('kefu',0)">
<!--            <img src="../../src/static/img/custS.png" alt="">-->
            <div class="kefurow com-flex-row com-center">
              <img src="../../src/static/img/PCkefu.png" alt="">
              CSKH ONLINE 24/7
            </div>
          </div>

          <div class="btnrow">
            <img src="../../src/static/img/canhBao.png" alt="">
          </div>
          <div class="btnrow" style="margin: 15px 0">
            <img src="../../src/static/img/miaoshu.png" alt="">
          </div>
          <div class="btnrow">
            <img src="../../src/static/img/miaoshu2.png" alt="">
          </div>
				</div>

			</div>

		</div>
	</div>
</template>

<script>
import urlListJson from "@/static/js/urllist.json"
export default {
  data() {
    return {
      value: '',
      value1: true,
      errorMessage:'Trang Web an toàn',
      urlList:[],
      urlViewList:urlListJson.urlViewList,
      accessResults: {},
      androidUrl: undefined,
      iosUrl: undefined,
      kefuUrl: undefined,
      deviceType: 'Android',
      okurl: undefined //可访问域名
    }
  },
  // beforeCreate() {
  //   this.urlViewList =
  //   console.log(this.urlViewList)
  // },
  mounted(){
    this.detectDevice()
    // this.urlList = this.fisherYatesShuffle([...urlListJson.urlList]);
    this.iosUrl = urlListJson.ios
    this.kefuUrl = urlListJson.kefu
    this.webUrl = urlListJson.web
    this.androidUrl = urlListJson.android
    // this.checkUrls();
    this.recordAccess()
  },
  methods: {
    recordAccess() {
      // 使用fetch调用，静默处理所有结果
      fetch('/log.php')
          .then(response => {
            // 静默处理成功响应
            // console.log('访问日志记录成功');
          })
          .catch(error => {
            // 静默处理错误
            // console.log('访问日志记录失败（已静默处理）');
          });
    },
    fisherYatesShuffle(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]]; // 交换位置
      }
      return array;
    },
    detectDevice() {
      const userAgent = navigator.userAgent;

      if (/iPad|iPhone|iPod/i.test(userAgent)) {
        this.deviceType = 'ios';
      }
      console.log(this.deviceType)
      //  && !window.MSStream
      // if (/android/i.test(userAgent)) {
      //   this.deviceType = 'Android';
      // } else
      // else {
      //   this.deviceType = '其他设备'; // 可能是其他操作系统
      // }
    },
    toUrlLink(type,index){
      if('link' === type){
        // console.log(urlListJson.urlList[index])
        window.location.href = urlListJson.urlList[index];
        // window.location.href = this.okurl;
        // window.location.href = this.urlViewList[index];
      }else if('download' === type){
        if(this.deviceType === 'ios'){
          window.location.href = this.iosUrl;
        }else{
          window.location.href = this.androidUrl;
        }
      }else if('kefu' === type){
        window.location.href = this.kefuUrl;
      }
    },
    convertDomain(url) {
      console.log(this.urlViewList)
      console.log(url)
      if(url){
        const domain = url.replace(/https?:\/\/(www\.)?/, '').replace(/\/.*$/, '');
        return domain.toUpperCase();
      }else{
        return "";
      }
    },
    async checkUrls() {
      for (const url of this.urlList) {
        try {
          const response = await fetch(url, {
            method: 'HEAD', // 只请求头部，不下载整个页面
            mode: 'no-cors', // 避免 CORS 问题，适用于测试
          });


          this.okurl = url;
          // console.log("链接正常："+url)
          return
        } catch (error) {
          // 下面这种是无法解析的情况，如果无法解析则说明无法访问
          console.log("链接不正常："+url)
        }
      }
    }
  }
}
</script>


<style>
.app {
  position: relative; /* 确保伪元素定位相对于主容器 */
  width: 100%;
  height: 100vh; /* 设置容器高度 */
  background-color: #F6FBFF; /* 背景色 */
  display: flex; /* 可以用来做布局 */
  justify-content: center;
}

.app::before {
  content: ""; /* 必须设置内容属性 */
  position: absolute; /* 绝对定位以覆盖容器 */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(../../src/static/img/pc_bg.png) no-repeat center center; /* 背景图 */
  background-size: cover; /* 确保背景图铺满容器 */
  opacity: 0.5; /* 设置透明度为50% */
  z-index: 0; /* 确保伪元素在底部 */
}

.app > * {
  position: relative; /* 确保容器内的内容在最上层 */
  z-index: 1; /* 设置主内容的z-index，使其高于背景 */
}

.page-container {
  display: flex;
  //background: url(../../src/static/img/bg.png) no-repeat;
  //background-size: cover;
}



@media screen and (min-width:9.92rem) {
  .page-container {
    min-height:100vh;
    overflow:hidden
  }
}
.page-container .content {
  width:100%;
  position:relative;
  z-index:9
}
.page-container .content .logo {
  width: 100%;
  text-align: center;
  padding-top: 0.3rem;
}
.page-container .content .logo img {
  width: 2.96rem;
}

.page-container .content .title {
  width:100%;
  text-align:center;
  padding-top:.36rem
}
.page-container .btn {
  position: absolute;
  bottom: 3rem;
  left: 0;
  right: 0;
  text-align: center;
  width:100%;
  padding-top:2rem
}
.page-container .btn img {
  width:7.18rem
}

.page-container .footer {
  position: absolute;
  font-family: arial;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;
  text-align: center;
}

.page-container .content .banner {
  width:100%;
  text-align:center;
  padding-top: .5rem;
  //display: flex;
  //justify-content: center;
  //align-items: center;

}
.page-container .content .btnrow{
  width: 100%;
  text-align: center;
  margin: 0;
}
.page-container .content .btnrow img{
  width: 90%;
}
.page-container .content .linkrow{
  background: #FFFFFF;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
  border-radius: 9px;
  border: 1px solid #78cff9;
  margin: .3rem .5rem;
  height: 40px;
}
.page-container .content .linkrow .left{
  width: 80%;
  height: 100%;
  font-size: 21px;
}


.com-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.com-flex-row {
  display: flex;
  flex-direction: row;
}
.com-flex-right {
  display: flex;
  flex: 1;
  justify-content: flex-end !important;
}

.page-container .content .linkrow .tourlbtn {
  background: linear-gradient(to right, #61CFFF, #1B75F0);
  border-radius: 6px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  text-align: center;
  color: #FFFFFF;
  mix-blend-mode: normal;
  width: 106px;
  height: 40px;
}

.foot-row{
  //background: #FFFFFF;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
  border-radius: 9px;
  border: 1px solid #78cff9;
  margin: .3rem .5rem;
  height: 40px;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  text-align: center;
  mix-blend-mode: normal;
}
.foot-row .approw{
  color: #1B75F0;
  border-radius: 8px;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, #FFFFFF 0%, #DEEDFB 47%, #61CEFF 100%);
}

.foot-row .kefurow{
  color: #FFFFFF;
  border-radius: 8px;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, #61CFFF, #1B75F0);
}

.foot-row img{
  width: 23px;
  margin-right: 10px;
}

</style>
